import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import InvitePage from "@/pages/InvitePage";
import AdminPage from "@/pages/AdminPage";

const RootGate = () => (
  <div className="min-h-screen bg-cream flex flex-col items-center justify-center px-6 text-center">
    <p className="overline-label text-bronze mb-6" data-testid="root-overline">Leticia &amp; Nick</p>
    <h1 className="font-serif text-4xl sm:text-5xl font-light text-ink tracking-tight" data-testid="root-title">
      Esta invitación es personal
    </h1>
    <p className="mt-6 max-w-md text-sm text-taupe leading-relaxed" data-testid="root-message">
      Por favor utiliza el enlace personalizado que recibiste con tu invitación para ver tus pases asignados.
    </p>
    <Link to="/admin" className="mt-10 text-xs uppercase tracking-[0.3em] text-bronze underline-offset-4 hover:underline" data-testid="root-admin-link">
      Acceso novios
    </Link>
  </div>
);

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootGate />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/:code" element={<InvitePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
